import useBranding from "hooks/useBranding";
import InfoIcon from "../../../components/InfoIcon/InfoIcon";
import "./DisplaySeats.scss";

const DisplaySeats = ({ maxSeats, usedSeats }) => {
	const { contactDetails } = useBranding();
	const barWidthPercent = (usedSeats / maxSeats) * 100;
	let hasContactDetails = [contactDetails.Number, contactDetails.Email].some(value => value && value.trim() !== "");

	return (
		<div className="displaySeats">
			<h3>
				You have {maxSeats - usedSeats} seat(s) remaining{" "}
				<InfoIcon
					html={`<p class="popup"><strong>To add more seats to your package, please contact us.</strong>${hasContactDetails
							? `<br /><br />${contactDetails.Number}<br />${contactDetails.Email}`
							: ""
						}</p>`}
				/>
			</h3>
			<div className="displaySeats-amount">
				<span className="displaySeats-amount-bar" style={{ width: `${barWidthPercent}%` }}></span>
				<p>{usedSeats} / {maxSeats}</p>
			</div>
		</div>
	);
};

export default DisplaySeats;
